"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._TestVoucherCode = exports._VouchercodeRequest = void 0;
var api_wrapper_1 = require("@src/api/api-wrapper");
var contract_const_1 = require("@src/const/contract.const");
var custom_dom_names_const_1 = require("@src/const/custom-dom-names.const");
var customer_preview_const_1 = require("@src/const/customer-preview.const");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var error_helper_const_1 = require("@src/const/error-handling/error-helper.const");
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
var inter_communication_service_1 = require("@src/services/inter-communication.service");
var module_handler_service_1 = require("@src/services/module-handler.service");
var object_service_1 = require("@src/services/object-service");
var settings_service_1 = require("@src/services/settings.service");
var translation_1 = __importDefault(require("@src/services/translation"));
var cash_dom_1 = __importDefault(require("cash-dom"));
var topfit_voucher_fallback_const_1 = require("./topfit-voucher-fallback.const");
var _VouchercodeRequest = function (voucherCode, studioId) { return __awaiter(void 0, void 0, void 0, function () {
    var apiWrapper, settings, payload, error_1, fallback;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                apiWrapper = object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper);
                settings = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
                payload = {
                    voucherCode: voucherCode,
                    studioId: +studioId,
                    contract: (0, contract_const_1._CreateBaseContract)(),
                    customer: customer_preview_const_1.PreviewCustomer,
                };
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, apiWrapper.validateVoucher(payload)];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                error_1 = _b.sent();
                fallback = (_a = (0, topfit_voucher_fallback_const_1._GetTopfitVoucherFallback)(settings.get.tenantKey, voucherCode, error_1 === null || error_1 === void 0 ? void 0 : error_1.status)) !== null && _a !== void 0 ? _a : (0, topfit_voucher_fallback_const_1._GetVoucherServerErrorFallback)(error_1 === null || error_1 === void 0 ? void 0 : error_1.status, error_1 === null || error_1 === void 0 ? void 0 : error_1.errorCodes);
                if (fallback)
                    return [2 /*return*/, fallback];
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
exports._VouchercodeRequest = _VouchercodeRequest;
/**
 * DEPRECATED AND CRAP JUST UNTIL WE HAVE A VOUCHERCODE MODULE in 2.2 workardound for 2.1.0
 * @returns
 */
var _TestVoucherCode = function ($container) { return __awaiter(void 0, void 0, void 0, function () {
    var allModules, pricePreview, communicationService, voucherElem, inputValue, voucherContainer, resultElem, validVoucher, errorMsg, result_1, result, successRow, successMessage, err_1, errorMessage, result;
    var _a, _b, _c, _d, _e, _f, _g;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                allModules = (0, module_handler_service_1._AllBootstrappedModulesArray)();
                pricePreview = (_a = allModules.find(function (a) { return a.instance.moduleKey === 'price-preview'; })) === null || _a === void 0 ? void 0 : _a.instance;
                communicationService = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
                voucherElem = $container.find('#' + input_mapping_const_1._AllMappings.voucherCode.uid);
                if (!(voucherElem === null || voucherElem === void 0 ? void 0 : voucherElem.length)) {
                    voucherElem = $container.find("[data-get=\"".concat(input_mapping_const_1._AllMappings.voucherCode.uid, "\"]"));
                }
                // the price preview is validated outside a container (e.g. membership completion) but the comp tries to validate with it.
                if (!(voucherElem === null || voucherElem === void 0 ? void 0 : voucherElem.length)) {
                    voucherElem = (0, cash_dom_1.default)("[data-get=\"".concat(input_mapping_const_1._AllMappings.voucherCode.uid, "\"]"));
                }
                (0, error_helper_const_1._RemoveStatusFromDomObject)(voucherElem);
                if ((0, input_output_helper_const_1._GetFieldDomObj)(input_mapping_const_1._AllMappings.voucherCode, $container).length) {
                    inputValue = (0, input_output_helper_const_1._ReadField)(input_mapping_const_1._AllMappings.voucherCode, $container);
                }
                else {
                    inputValue = localStorage.getItem(input_mapping_const_1._AllMappings.voucherCode.uid);
                }
                if (!(inputValue === null || inputValue === void 0 ? void 0 : inputValue.length))
                    return [2 /*return*/, { valid: true, data: { voucherCode: inputValue } }];
                // workaround until successmessages are cleaned up properly
                voucherElem.siblings(".".concat(custom_dom_names_const_1._ClassNames.successfield)).remove();
                voucherContainer = voucherElem;
                resultElem = (0, cash_dom_1.default)('[data-ref="voucherResultMessage"]');
                if (resultElem.length) {
                    voucherContainer = resultElem;
                }
                _h.label = 1;
            case 1:
                _h.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (0, exports._VouchercodeRequest)(inputValue, (_b = (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.studioId)) !== null && _b !== void 0 ? _b : '-')];
            case 2:
                validVoucher = _h.sent();
                if (!(validVoucher === null || validVoucher === void 0 ? void 0 : validVoucher.voucherSuccessMessage)) {
                    errorMsg = translation_1.default.t('Invalid voucher');
                    (0, error_helper_const_1._AddErrorToDomObject)(voucherContainer, translation_1.default.t(errorMsg));
                    result_1 = { valid: false, data: { voucherCode: '' }, error: errorMsg };
                    if ((pricePreview === null || pricePreview === void 0 ? void 0 : pricePreview.useDatahandlers) === false) {
                        (_c = pricePreview === null || pricePreview === void 0 ? void 0 : pricePreview.renderPricePreview) === null || _c === void 0 ? void 0 : _c.clearVoucherPreview();
                        (_d = pricePreview === null || pricePreview === void 0 ? void 0 : pricePreview.renderPricePreview) === null || _d === void 0 ? void 0 : _d.removePricingDetails();
                    }
                    else {
                        // pricePreview.renderPricePreviewDataHandlers.updateDataHandlers(result);
                    }
                    communicationService.sendEvent({
                        event: 'globalCustom',
                        name: 'voucherCodeValidationResult',
                        value: result_1,
                    });
                    return [2 /*return*/, result_1];
                }
                result = {
                    valid: true,
                    data: {
                        voucherCode: inputValue,
                        discount: validVoucher.discountValue,
                        discountValue: validVoucher.discountValue,
                        discountType: validVoucher.discountType,
                        discountedBasePrice: validVoucher.discountedBasePrice,
                        discountedPreUseCharge: validVoucher.discountedPreUseCharge,
                        creditValue: validVoucher.creditValue,
                        effectivePeriodTimeBasedTerm: validVoucher.effectivePeriodTimeBasedTerm,
                        effectivePeriodTimeBasedTermUnit: validVoucher.effectivePeriodTimeBasedTermUnit,
                        flatFeePreviews: validVoucher.flatFeePreviews,
                        selectedOptionalModulesPreviews: validVoucher.selectedOptionalModulesPreviews,
                    },
                };
                if ((pricePreview === null || pricePreview === void 0 ? void 0 : pricePreview.useDatahandlers) === false) {
                    successRow = (0, generator_const_1._GetRow)({ html: validVoucher.voucherSuccessMessage }, 'success', { 'data-voucher-success-message': 'true' });
                    if (pricePreview === null || pricePreview === void 0 ? void 0 : pricePreview.renderPricePreview) {
                        pricePreview.renderPricePreview.preview = __assign(__assign({}, pricePreview.renderPricePreview.preview), validVoucher);
                    }
                    (_e = pricePreview === null || pricePreview === void 0 ? void 0 : pricePreview.renderPricePreview) === null || _e === void 0 ? void 0 : _e.appendPricingDetails(successRow);
                }
                else {
                    // pricePreview.renderPricePreviewDataHandlers.updateDataHandlers(result);
                }
                successMessage = translation_1.default.t(validVoucher.voucherSuccessMessage
                    .replace(/\bIhrem\b/g, 'Deinem')
                    .replace(/\bIhren\b/g, 'Deinen')
                    .replace(/\bIhre\b/g, 'Deine')
                    .replace(/\bIhr\b/g, 'Dein')
                    .replace(/\bihrem\b/g, 'deinem')
                    .replace(/\bihren\b/g, 'deinen')
                    .replace(/\bihre\b/g, 'deine')
                    .replace(/\bihr\b/g, 'dein'));
                (0, error_helper_const_1._AddSuccessToDomObject)(voucherContainer, successMessage);
                communicationService.sendEvent({
                    event: 'globalCustom',
                    name: 'voucherCodeValidationResult',
                    value: result,
                });
                return [2 /*return*/, result];
            case 3:
                err_1 = _h.sent();
                console.error('Voucher validation error:', err_1);
                errorMessage = (err_1 === null || err_1 === void 0 ? void 0 : err_1.message) || String(err_1);
                (0, error_helper_const_1._AddErrorToDomObject)(voucherContainer, translation_1.default.t(errorMessage));
                result = { valid: false, data: { voucherCode: '' }, error: translation_1.default.t(errorMessage) };
                if ((pricePreview === null || pricePreview === void 0 ? void 0 : pricePreview.useDatahandlers) === false) {
                    (_f = pricePreview === null || pricePreview === void 0 ? void 0 : pricePreview.renderPricePreview) === null || _f === void 0 ? void 0 : _f.clearVoucherPreview();
                    (_g = pricePreview === null || pricePreview === void 0 ? void 0 : pricePreview.renderPricePreview) === null || _g === void 0 ? void 0 : _g.removePricingDetails();
                }
                else {
                    //pricePreview.renderPricePreviewDataHandlers.updateDataHandlers(result);
                }
                communicationService.sendEvent({
                    event: 'globalCustom',
                    name: 'voucherCodeValidationResult',
                    value: result,
                });
                return [2 /*return*/, result];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports._TestVoucherCode = _TestVoucherCode;
